// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function setFieldWidth(ydb: Database, fieldId: string, width: number): void {
  ydb.mutate((db) => {
    db.fieldsById[fieldId].width = width;
  });
}
